import React, { FC } from 'react';

type AppColProps = {
    col?: number
    className?: string
    children?: React.ReactNode;
}

const AppCol: FC<AppColProps> = (props) => {
  return (
    <div
      className={
        `
                col-xs-${props.col || 12} 
                ${props.className || ''}
                pl-1
                pr-1
                `
      }
    >
      { props.children }
    </div>
  );
};


export default AppCol;
